import React from 'react';
import PropTypes from 'prop-types';
import Script from 'react-load-script';
import isUrl from 'is-url';
import log from 'loglevel';
import { useMeasure } from 'react-use';

import Loading from 'Components/Loading';
import { useConfig } from 'Context/ConfigContext';

import NoteBoardWrapper from './NoteBoardWrapper';

const handleNoteboardModuleLoaded = (noteBoardOptions) => {
  let NoteBoardApp;
  if (window.NoteboardModule) {
    NoteBoardApp = window.NoteboardModule.new({
      selector: '#NoteBoardApp',
      options: noteBoardOptions,
    });
  }
  if (NoteBoardApp) {
    NoteBoardApp.render();
  } else {
    log.error('NoteBoardApp instance is missing.');
  }
};

const ELEMENT_MAX_WIDTH = 1280;
const ELEMENT_MAX_HEIGHT = 720;
function NoteBoard({
  value,
  onCompleted,
  assetReferId,
  userAssetDocument,
  userAssetDataError,
  isUserAssetDataLoading,
  onUpdateUserAsset,
}) {
  const { noteBoardModuleUrl: NOTEBOARD_MODULE_URL } = useConfig();
  const [ref, { width }] = useMeasure();

  if (!isUrl(NOTEBOARD_MODULE_URL)) {
    return null;
  }

  if (userAssetDataError) {
    log.error(userAssetDataError);
  }

  const noteBoardOptions = {
    id: assetReferId,
    onCompleted: onCompleted,
    onChange: ({ userAssetDoc }) => onUpdateUserAsset(userAssetDoc),
    userAssetNotes: userAssetDocument?.userNotes ?? null,
    ...value,
  };

  if (isUserAssetDataLoading) {
    return Loading({});
  }

  return (
    <div
      ref={ref}
      style={{ margin: '0 auto', maxWidth: `${ELEMENT_MAX_WIDTH}px`, overflow: 'hidden' }}
    >
      <NoteBoardWrapper>
        <div
          id="NoteBoardApp"
          style={{
            width: `${ELEMENT_MAX_WIDTH}px`,
            height: `${ELEMENT_MAX_HEIGHT}px`,
            overflow: 'visible',
            transform: `scale(${width / ELEMENT_MAX_WIDTH})`,
            transformOrigin: 'top left',
          }}
        />
        <Script
          url={NOTEBOARD_MODULE_URL}
          onLoad={() => {
            handleNoteboardModuleLoaded(noteBoardOptions);
          }}
        />
      </NoteBoardWrapper>
    </div>
  );
}

NoteBoard.propTypes = {
  assetReferId: PropTypes.string,
  value: PropTypes.object,
  onCompleted: PropTypes.func,
  userAssetDocument: PropTypes.shape({
    userAssetNotes: PropTypes.arrayOf(
      PropTypes.shape({
        color: PropTypes.number,
        position: { x: PropTypes.number, y: PropTypes.number },
        text: PropTypes.string,
      })
    ),
  }),
  onUpdateUserAsset: PropTypes.func,
  userAssetDataError: PropTypes.string,
  isUserAssetDataLoading: PropTypes.bool,
};

export default NoteBoard;
